import { localDateStr } from '../../utils/localDate';

// A day the employee marked in on and never marked out. The DB keeps such a row
// 'in-progress' until the attendance sweep closes it at the next day's shift
// start (or until they mark in again), but a day that's already over can't be
// "in progress" — so the views show it as not marked out instead.
export const NOT_MARKED_OUT = 'not-marked-out';

// The status to show for an attendance record: 'in-progress' on a past date
// becomes NOT_MARKED_OUT; everything else passes through unchanged.
export const displayStatus = (rec, today = localDateStr(new Date())) => {
  const status = rec?.status;
  if (status !== 'in-progress') return status;
  const day = String(rec?.date || '').slice(0, 10);
  return day && day < today ? NOT_MARKED_OUT : status;
};
